import { graphql } from 'react-relay';

export const orColumnSubscription = graphql`
  subscription ORColumnSubscription($id: ID!) {
    operatingRoomScheduleUpdate(operatingRoomId: $id) {
      node {
        id
        name
        plannedStart
        plannedStop
        estimatedStartTime
        estimatedStopTime
        actualStartTime
        actualStopTime
        patientMrn
        patientName
        surgeonName
        serviceName
        status
        scheduleStatus
        location {
          name
        }
        durations {
          dynamicDurationMinutes
          delayAfterMinutes
          plannedDurationMinutes
        }
        estimateSource
        template {
          category
        }
        events(first: 20) {
          edges {
            node {
              id
              happenedAt
              type {
                id
                name
              }
            }
          }
        }
        turnover {
          id
          name
          plannedStart
          plannedStop
          estimatedStartTime
          estimatedStopTime
          actualStartTime
          actualStopTime
          status
          scheduleStatus
          durations {
            dynamicDurationMinutes
            delayAfterMinutes
            plannedDurationMinutes
          }
          estimateSource
          template {
            category
          }
          events(first: 20) {
            edges {
              node {
                id
                happenedAt
                type {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;
